__turbopack_context__.v({
  "cta": "Form-module-scss-module__6dPngW__cta",
  "field": "Form-module-scss-module__6dPngW__field",
  "form-error": "Form-module-scss-module__6dPngW__form-error",
  "headline": "Form-module-scss-module__6dPngW__headline",
  "no-break": "Form-module-scss-module__6dPngW__no-break",
  "placeholder": "Form-module-scss-module__6dPngW__placeholder",
  "section": "Form-module-scss-module__6dPngW__section",
  "spaced": "Form-module-scss-module__6dPngW__spaced",
  "sub-headline": "Form-module-scss-module__6dPngW__sub-headline",
  "subsection": "Form-module-scss-module__6dPngW__subsection",
});
